import { render, staticRenderFns } from "./OPDCard.vue?vue&type=template&id=1332e95a&scoped=true&"
import script from "./OPDCard.vue?vue&type=script&lang=js&"
export * from "./OPDCard.vue?vue&type=script&lang=js&"
import style0 from "./OPDCard.vue?vue&type=style&index=0&id=1332e95a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1332e95a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1209661745/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1332e95a')) {
      api.createRecord('1332e95a', component.options)
    } else {
      api.reload('1332e95a', component.options)
    }
    module.hot.accept("./OPDCard.vue?vue&type=template&id=1332e95a&scoped=true&", function () {
      api.rerender('1332e95a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FromTemplates/OPDCard.vue"
export default component.exports